import React from 'react'
import { Routes, Route } from 'react-router-dom'
import Header from '@/components/header'
import HeroBanner from '@/components/hero-banner'
import Footer from '@/components/footer'
import Providers from '@/components/providers'
import { Toaster } from '@/components/ui/sonner'
import VConsoleInit from '@/components/vconsole-init'

// Import pages - these will be created from Next.js pages
import HomePage from '@/pages/Home'
import BookingServicePage from '@/pages/BookingService'
import BookingSchedulePage from '@/pages/BookingSchedule'
import BookingModePage from '@/pages/BookingMode'
import BookingSuccessPage from '@/pages/BookingSuccess'
import BookingHistoryPage from '@/pages/BookingHistory'
import AuthVerifyPage from '@/pages/AuthVerify'
import AuthOtpPage from '@/pages/AuthOtp'
import AuthOtherOtpPage from '@/pages/AuthOtherOtp'
import AuthRegisterPage from '@/pages/AuthRegister'
import ProfilePage from '@/pages/Profile'
import MapPage from '@/pages/Map'
import HelpPage from '@/pages/Help'
import TermsPage from '@/pages/Terms'
import ReschedulePage from '@/pages/Reschedule'
import OrganizationDarsPage from '@/pages/OrganizationDars'
import TryPage from '@/pages/Try'

function App() {
  return (
    <Providers>
      <Toaster position="top-right" richColors />
      <Header />
      <div className="">
        <HeroBanner />
      </div>
      <div className="relative z-10 bg-background flex flex-col flex-1">
        <div className='flex justify-center'>
          <div className="flex-1 max-w-[1250px] min-h-0">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/booking/service" element={<BookingServicePage />} />
              <Route path="/booking/schedule" element={<BookingSchedulePage />} />
              <Route path="/booking/mode" element={<BookingModePage />} />
              <Route path="/booking/success" element={<BookingSuccessPage />} />
              <Route path="/booking/history" element={<BookingHistoryPage />} />
              <Route path="/auth/verify" element={<AuthVerifyPage />} />
              <Route path="/auth/otp" element={<AuthOtpPage />} />
              <Route path="/auth/other-otp" element={<AuthOtherOtpPage />} />
              <Route path="/auth/register" element={<AuthRegisterPage />} />
              <Route path="/profile" element={<ProfilePage />} />
              <Route path="/map" element={<MapPage />} />
              <Route path="/help" element={<HelpPage />} />
              <Route path="/terms-and-conditions" element={<TermsPage />} />
              <Route path="/reschedule" element={<ReschedulePage />} />
              <Route path="/organization/dars" element={<OrganizationDarsPage />} />
              <Route path="/try" element={<TryPage />} />
            </Routes>
          </div>
        </div>
        <Footer text={'© 2025 Cheche. All rights reserved.'} />
      </div>
    </Providers>
  )
}

export default App
